// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2XiJA","buttons":"PendingPaymentAlert_buttons__2a3_k"};